"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const DataBuilderFieldContext = createContext({
  field: { level: 0, optionFactories: [] },
  localSchema: {},
  setLocalSchema: () => {
  },
  resetLocalSchema: () => {
  },
  localSchemaChangedManually: false,
  setLocalSchemaChangedManually: () => {
  },
  autoOpen: false,
  setAutoOpen: () => {
  }
});
DataBuilderFieldContext.displayName = "DataBuilderFieldContext";
function useDataBuilderField() {
  return useContext(DataBuilderFieldContext);
}

export { DataBuilderFieldContext, useDataBuilderField as default };
